import Icon from '../components/Icon.vue'

Icon.register({
  hammer: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M571.3 193.9c6.3 6.3 6.3 16.4 0 22.6l-90.5 90.5c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.3-6.3-16.4 0-22.6l11.3-11.3-28.9-28.9c-21.3 5.6-44.9 0.4-61.6-16.3l-49.1-49.1c-12-12-18.8-28.3-18.8-45.3v-18.8l-90.5-45.3c62.5-62.5 163.8-62.5 226.3 0l45.3 45.3c16.7 16.7 22 40.3 16.3 61.6l28.9 28.9 11.3-11.3c6.3-6.3 16.4-6.3 22.6 0zM284.6 178.7l49.1 49.1c3.5 3.5 7.5 6.5 11.4 9.4l-238.1 255.1c-23.9 25.6-64.2 26.3-88.9 1.5-24.7-24.7-24-65 1.5-88.9l255.1-238.2c3 4.2 6.1 8.3 9.8 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hammer.js
// module id = 1422
// module chunks = 0